import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { fetchPackage } from './Api';
import { useParams, useHistory } from 'react-router-dom';
import { Contextone } from './Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import logo from '../images/aaryaottlogo.png';
import Cookies from 'js-cookie';
import globalSetting from "../configuration.js";
import { logAnalyticsEvent } from "./Script.js";


const Subscription = () => {
    const { urls, movie, encode } = useParams();
    const [page, setPage] = useState([]);
    const [couponOption, setCouponOption] = useState(false);
    const [couponNo, setCouponNo] = useState("");
    const [couponErr, setCouponError] = useState("");
    const [isPackageName, setPackageName] = useState('');
    const [isPackageIdd, setPackageIdd] = useState(0);
    const [isNewAmt, setNewAmt] = useState(0);
    const [paymentOptions, setPaymentOptions] = useState({});
    const [userSubscribe, setUserSubscribe] = useState([]);

    // const uid = localStorage.getItem('userid');
    const uphone = localStorage.getItem('userPhone');
    const uemail = localStorage.getItem('userEmail');
    const countercontext = useContext(Contextone);
    const url = countercontext.isDomain;
    const apiUrl = `https://${url}`;
    const apiLogo = countercontext.isLogo
    const history = useHistory();
    const uid = Cookies.get('userid');

    if(!uid){
        Cookies.set('loc', history.location.pathname)
      }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchPackage(apiUrl);
                setPage(data.result);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchData();
    }, [uid]);

    const fetchSubscriptionList = async () => {
        if(uid){
            try {
                const response = await fetch(apiUrl + '/api/subscription_list', {
                    method: 'POST',
                    body: JSON.stringify({ user_id: uid }),
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    }
                });
                const data = await response.json();
                setUserSubscribe(data.result);
            } catch (error) {
                console.error('Error fetching subscription list:', error);
            }
        }
        
    };
    
    useEffect(() => {
        fetchSubscriptionList();
    }, [uid]);
    
    const addTransaction = async (amount, payId, packageId, name) => {
        try {
            const response = await fetch(apiUrl + '/api/add_transaction', {
                method: 'POST',
                body: JSON.stringify({
                    user_id: uid,
                    package_id: packageId,
                    description: name,
                    amount: amount,
                    payment_id: payId,
                    currency_code: "",
                    unique_id: ""
                }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                }
            });
            const data = await response.json();
    
            fetchSubscriptionList();
        } catch (error) {
            console.error('Error adding transaction:', error);
        }
    };

    useEffect(() => {
        const fetchPaymentOptions = async () => {
            try {
                const response = await fetch(apiUrl + '/api/get_payment_option', {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    }
                });
                const data = await response.json();
                setPaymentOptions(data.result);
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchPaymentOptions();
    }, []);


    const addOrderId = async (amount, email, contact, name, packageId) => {
        try {
            const response = await fetch(apiUrl + '/api/create-order', {
                method: 'POST',
                body: JSON.stringify({
                    amount: amount,
                    currency: "INR",
                    name: name,
                    mobile: contact,
                    email: email
                }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                }
            });
            const data = await response.json();
            const oId = data.status;
            if (oId === 200 || oId === "" || oId === null) {
                handlePayment(amount, packageId, name, data.result.id);
                setCouponOption(false)

            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const addCoupon = async (amt, couponDetail, packageId) => {
        try {
            const response = await fetch(apiUrl + '/api/apply_coupon', {
                method: 'POST',
                body: JSON.stringify({
                    user_id: uid,
                    apply_coupon_type: "1",
                    unique_id: couponDetail,
                    package_id: packageId,
                }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                }
            });
            const data = await response.json();
            if (data.message === 'Coupon Code Wrong.') {
                setCouponError('Coupon Code Wrong.');
                setNewAmt(amt);
            } else {
                setNewAmt(data.result.discount_amount);
                setCouponError("Coupon applied")
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };    

    const handlePayment = async (amount, packageId, name, orderId) => {
        const razorpayOptions = paymentOptions.razorpay;
        if (!razorpayOptions) {
            console.error('Razorpay options not loaded');
            return;
        }

        const key = razorpayOptions.is_live === "1" ? razorpayOptions.live_key_1 : razorpayOptions.test_key_1;

        try {
            const options = {
                key: key,
                amount: amount * 100,
                currency: "INR",
                name: name,
                order_id: orderId,
                packageId: packageId,
                image: apiLogo,
                prefill: {
                    userId: uid,
                    email: uemail,
                    contact: uphone,
                },
                autocapture: 1,
                theme: {
                    color: "#3399cc"
                },
                handler: function (response) {
                    logAnalyticsEvent('Razorpay Payment Success', {
                        amount,
                        packageId,
                        paymentId: response.razorpay_payment_id,
                        orderId,
                        uid, name, uphone, uemail
                    });
                    addTransaction(amount, response.razorpay_payment_id, packageId, name);
                },
                modal: {
                    ondismiss: function () {
                        // Log payment modal dismissal
                        logAnalyticsEvent('Razorpay Payment Failed', { packageId, orderId, amount, uid, name, uphone, uemail });
                    }
                }
            };
            const rzp1 = new window.Razorpay(options);
            logAnalyticsEvent('Razorpay open', { packageId, orderId,amount, uid, name, uphone, uemail });
            rzp1.open();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        if(uid){
            userSubscribe.forEach(mtype => {
                if (mtype.user_id == uid) {
                    countercontext.isPremium = true;
                    if(encode){
                        history.push(`/${urls}/${movie}/${encode}`)
                    }   
                }
            });
        }
        
    }, [userSubscribe]);

    const handlePaymentBackBtn = () => {
        setCouponOption(false)
        setCouponNo('')
        setCouponError("")
    }

    const closeCouponBox = (isNewAmt, isPackageName, isPackageIdd) => {
        withoutRazorpay()
        addTransaction(isNewAmt, null, isPackageIdd, isPackageName)
        // if(id){
        //     history.push(`/videodetails/${typeid}/${id}/${utype}/${vtype}`) 
        // }

    }
    const withoutRazorpay = () => {
        setCouponOption(false)
        setCouponNo('')
    }

    return (
        <>
            <div className="top-left-button">
                <button onClick={() => history.goBack()} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#000', cursor: 'pointer' }}>
                    <FontAwesomeIcon icon={faArrowLeft} style={{ color: 'white' }} />
                </button>
            </div>
            <div className="black-background">
                <div className="card-deck-wrapper">
        {page.map((mtype, index) => {
            const isSubscribed = userSubscribe.some(subscription => subscription.package_id === mtype.id);
            const anyPageSubscribed = userSubscribe.length > 0;
            return (
                <div key={index} className="container card-container">
                    <div className="card mb-4 shadow-sm black-card">
                        <div className="card-header-custom red-text">
                            <h4 className="my-0 font-weight-normal">{mtype.name}</h4>
                            <span>Rs {mtype.price}/{mtype.time}{mtype.type}</span>
                        </div>
                        <div className="card-body">
                            {mtype.data.map((content, key) => (
                                <div key={key}>
                                    <ul className="list-unstyled mt-3 mb-4 card-list">
                                        <li className='card-list-li'>{content.package_key}</li>
                                        <li>{content.package_value}</li>
                                    </ul>
                                </div>
                            ))}
                            {!isSubscribed ? (
                                <button
                                    type="button"
                                    className="btn btn-lg btn-block btn-primary planBtn"

                                    {...(anyPageSubscribed ? {} : { onClick: () => {
                                        if (uid) {
                                            const newAmount = mtype.price;
                                            const packageName = mtype.name;
                                            const packageId = mtype.id;
                                            setNewAmt(newAmount);
                                            setPackageName(packageName);
                                            setPackageIdd(packageId);
                                            setCouponOption(true);  
                                        } else {
                                            history.push('./NewLogin');
                                        }
                                    }})}
                                >
                                    Choose Plan
                                </button>
                            ) : (
                                <div class="alert alert-success">
                                     <strong>Subscribed!</strong> 
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        })}
                </div>
            </div>

            {couponOption && (
                <>
                    <div className="blur-background"></div>
                    <div className="payment-details">
                        <button className="back-button" onClick={handlePaymentBackBtn}>&larr;</button>
                        <h1>Payment Details</h1>
                        <div className="coupon-section">
                            <input
                                type="text"
                                value={couponNo}
                                onChange={(e) => setCouponNo(e.target.value)}
                                placeholder="Enter coupon code..."
                            />
                            <button
                                className="apply-button"
                                onClick={() => addCoupon(isNewAmt, couponNo, isPackageIdd)}
                            >
                                Apply
                            </button>
                        </div>
                        <div className="payable-amount-container">
                            <div className="payable-amount">
                                Payable amount is : <span className="amount">Rs {isNewAmt}</span>
                            </div>
                        </div>
                        <div className="payment-methods">
                            {/* <h2>Payment Methods</h2>
                        <p>Choose a payment method to</p> */}
                            <div className="pay-with">
                                <button
                                    className="razorpay-button"
                                    onClick={() => addOrderId(isNewAmt, uemail, uphone, isPackageName, isPackageIdd)}
                                >
                                    Pay
                                </button>
                            </div>
                        </div>
                        {couponOption && couponErr && (
                            <div>
                                <span className="error-message">{couponErr}</span>
                            </div>
                        )}
                    </div>
                </>
            )}

        </>
    );
}

export default Subscription;
